import { Component, OnInit,HostListener, NgZone } from '@angular/core';

@Component({
  selector: 'app-credentials',
  templateUrl: './credentials.component.html',
  styleUrls: ['./credentials.component.css']
})
@HostListener('window: resize', ['$event'])
export class CredentialsComponent implements OnInit {

  public innerHeight: any;
  load: boolean;

  getScreenHeight() {
    this.innerHeight = window.innerHeight + 'px';
  }

  constructor(private ngZone: NgZone) {
    window.onresize = (e) => {
      this.ngZone.run(() => {
        this.innerHeight = window.innerHeight + 'px';
      });
    };
    this.getScreenHeight();
  }

  ngOnInit() {
  
   
  }

  onResize(event) {
    this.innerHeight = event.target.innerHeight + 'px';
  }

}
